import React, { useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';
import { FaCheck, FaTimes, FaUserClock } from 'react-icons/fa';
import './PendingApprovals.css';

const PendingApprovals = ({ users, onApprove }) => {
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null
  });

  const handleApproveClick = (user) => {
    setConfirmDialog({
      isOpen: true,
      title: 'Approve User',
      message: `Are you sure you want to approve ${user.name}?`,
      onConfirm: () => {
        onApprove(user.id);
        setConfirmDialog({ ...confirmDialog, isOpen: false });
      }
    });
  };

  const handleRejectClick = (user) => {
    setConfirmDialog({
      isOpen: true,
      title: 'Reject User',
      message: `Are you sure you want to reject ${user.name}?`,
      onConfirm: () => {
        // Implement reject functionality
        setConfirmDialog({ ...confirmDialog, isOpen: false });
      }
    });
  };

  return (
    <div className="super-admin-pending">
      <h2><FaUserClock className="section-icon" /> Pending Approval Requests</h2>
      <div className="super-admin-table-container">
        <table className="super-admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Password</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.password}</td>
                <td>
                  <button 
                    className="super-admin-approve-btn"
                    onClick={() => handleApproveClick(user)}
                  >
                    <FaCheck /> Approve
                  </button>
                  <button 
                    className="super-admin-reject-btn"
                    onClick={() => handleRejectClick(user)}
                  >
                    <FaTimes /> Reject
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ConfirmationDialog
        isOpen={confirmDialog.isOpen}
        onClose={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
      />
    </div>
  );
};

export default PendingApprovals;